import trackingReducer from './reducer';

export const reducer = trackingReducer;
